<template>
  <div>
    <h2 id="ttl-service">
      <span class="txt-en">{{ $t(this.type) }}</span
      >{{ $t("partnerList") }}
    </h2>
    <div v-if="!comingsoon">
      <div
        class="flex-column kiyaku"
        v-for="(data, name, index) in this.displayList"
        :key="index"
      >
        <a :href="data.url">
          <img :src="data.img" :alt="data.alt" />
        </a>
        <p>{{ data.title }}</p>
        <p v-if="locale == 'en' && data.descriptionEN !== ''">
          {{ data.descriptionEN }}
        </p>
        <p v-if="locale == 'ja' && data.descriptionJP !== ''">
          {{ data.descriptionJP }}
        </p>
      </div>
    </div>
    <div class="kiyaku mb50" v-if="comingsoon">
      <img src="@/assets/img/coming-soon.png" />
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import utils from "@/utils/Utils";
import i18n from "../../i18n";

export default {
  name: "Partner",
  mixins: [utils, i18n],
  computed: {
    locale: function() {
      return i18n.locale;
    },
  },
  watch: {
    "$route.query.target"() {
      this.type = this.$route.query.target;
      this.load();
    },
  },
  data() {
    return {
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      displayList: [],
      partners: [],
      comingsoon: false,
      type: this.$route.query.target,
      localizing: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.displayList = [];
      let partners = await this.getPartners(this.db, this.type);
      let display = await this.getCorrespondingPartnerForUser(
        this.db,
        partners,
        this.user.uid
      );
      if (display == true) {
        this.comingsoon = true;
      } else {
        this.comingsoon = false;
        this.displayList = display;
      }
    },
  },
};
</script>
